import { render } from "./HcDeveloperCard.vue?vue&type=template&id=fc96bbee&scoped=true"
import script from "./HcDeveloperCard.vue?vue&type=script&lang=js"
export * from "./HcDeveloperCard.vue?vue&type=script&lang=js"

import "./HcDeveloperCard.vue?vue&type=style&index=0&id=fc96bbee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc96bbee"]])

export default __exports__